export const abi = [
	{
		inputs: [],
		name: 'acceptOwnership',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'deadline',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'excludedActivities',
				type: 'uint256'
			},
			{
				internalType: 'bool',
				name: 'flexible',
				type: 'bool'
			}
		],
		name: 'checkStakeForActivity',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			},
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			},
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'excludedActivities',
				type: 'uint256'
			}
		],
		name: 'checkStakeForActivity',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'claim',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'claim',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'deadline',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'flags',
				type: 'uint256'
			},
			{
				internalType: 'bool',
				name: 'flexible',
				type: 'bool'
			},
			{
				internalType: 'bool',
				name: 'exemptFromCooldownPeriod',
				type: 'bool'
			}
		],
		name: 'createNewLock',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'getClaimableStake',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'bool',
				name: 'perEventType',
				type: 'bool'
			}
		],
		name: 'getStakeData',
		outputs: [
			{
				components: [
					{
						internalType: 'uint256',
						name: 'totalStake',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalUnstakable',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalLocked',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalLockedFlexible',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalClaimable',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalPendingUnstake',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalExemptFromCooldownPeriod',
						type: 'uint256'
					},
					{
						internalType: 'uint256[]',
						name: 'totalLockedPerEventType',
						type: 'uint256[]'
					}
				],
				internalType: 'struct IStaking2aTypes.StakeDataResponse',
				name: '',
				type: 'tuple'
			}
		],
		stateMutability: 'view', // 'view' is hardcoded from the original contract abi, where is presented as nonpayable
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'bool',
				name: 'perEventType',
				type: 'bool'
			}
		],
		name: 'getStakeDataLatest',
		outputs: [
			{
				components: [
					{
						internalType: 'uint256',
						name: 'totalStake',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalUnstakable',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalLocked',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalLockedFlexible',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalClaimable',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalPendingUnstake',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalExemptFromCooldownPeriod',
						type: 'uint256'
					},
					{
						internalType: 'uint256[]',
						name: 'totalLockedPerEventType',
						type: 'uint256[]'
					}
				],
				internalType: 'struct IStaking2aTypes.StakeDataResponse',
				name: '',
				type: 'tuple'
			}
		],
		stateMutability: 'view', // 'view' is hardcoded from the original contract abi, where is presented as nonpayable
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'grantRole',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'initialize',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'deadline',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'flags',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'excludedActivities',
				type: 'uint256'
			}
		],
		name: 'lock',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'deadline',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'flags',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'excludedActivities',
				type: 'uint256'
			},
			{
				internalType: 'bool',
				name: 'flexible',
				type: 'bool'
			},
			{
				internalType: 'bool',
				name: 'exemptFromCooldownPeriod',
				type: 'bool'
			}
		],
		name: 'lock',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'lockIdx',
				type: 'uint256'
			}
		],
		name: 'releaseLock',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'renounceOwnership',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'callerConfirmation',
				type: 'address'
			}
		],
		name: 'renounceRole',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'revokeRole',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: 'newPeriod',
				type: 'uint256'
			}
		],
		name: 'setUnstakePeriod',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'stake',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'stake',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'transferOwnership',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		stateMutability: 'nonpayable',
		type: 'constructor'
	},
	{
		inputs: [],
		name: 'AccessControlBadConfirmation',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			},
			{
				internalType: 'bytes32',
				name: 'neededRole',
				type: 'bytes32'
			}
		],
		name: 'AccessControlUnauthorizedAccount',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'target',
				type: 'address'
			}
		],
		name: 'AddressEmptyCode',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'implementation',
				type: 'address'
			}
		],
		name: 'ERC1967InvalidImplementation',
		type: 'error'
	},
	{
		inputs: [],
		name: 'ERC1967NonPayable',
		type: 'error'
	},
	{
		inputs: [],
		name: 'FailedCall',
		type: 'error'
	},
	{
		inputs: [],
		name: 'InvalidInitialization',
		type: 'error'
	},
	{
		inputs: [],
		name: 'NotInitializing',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'owner',
				type: 'address'
			}
		],
		name: 'OwnableInvalidOwner',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'OwnableUnauthorizedAccount',
		type: 'error'
	},
	{
		inputs: [],
		name: 'ReentrancyGuardReentrantCall',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'SafeERC20FailedOperation',
		type: 'error'
	},
	{
		inputs: [],
		name: 'UUPSUnauthorizedCallContext',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'slot',
				type: 'bytes32'
			}
		],
		name: 'UUPSUnsupportedProxiableUUID',
		type: 'error'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			}
		],
		name: 'Claim',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'uint256',
				name: 'newMask',
				type: 'uint256'
			}
		],
		name: 'ExemptFromCooldownPeriodUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'uint64',
				name: 'version',
				type: 'uint64'
			}
		],
		name: 'Initialized',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'deadline',
				type: 'uint256'
			},
			{
				indexed: false,
				internalType: 'address',
				name: 'releaser',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'idx',
				type: 'uint256'
			}
		],
		name: 'LockReleased',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'deadline',
				type: 'uint256'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'flags',
				type: 'uint256'
			}
		],
		name: 'LockStake',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'previousOwner',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'OwnershipTransferStarted',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'previousOwner',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'OwnershipTransferred',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'previousAdminRole',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'newAdminRole',
				type: 'bytes32'
			}
		],
		name: 'RoleAdminChanged',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'account',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'sender',
				type: 'address'
			}
		],
		name: 'RoleGranted',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'account',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'sender',
				type: 'address'
			}
		],
		name: 'RoleRevoked',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			}
		],
		name: 'Stake',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'unstake',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'unstake',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'claimableAt',
				type: 'uint256'
			}
		],
		name: 'Unstake',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'uint256',
				name: 'newPeriod',
				type: 'uint256'
			}
		],
		name: 'UnstakePariodUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'implementation',
				type: 'address'
			}
		],
		name: 'Upgraded',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'newImplementation',
				type: 'address'
			},
			{
				internalType: 'bytes',
				name: 'data',
				type: 'bytes'
			}
		],
		name: 'upgradeToAndCall',
		outputs: [],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'recipient',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			}
		],
		name: 'withdraw',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'DEFAULT_ADMIN_ROLE',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			}
		],
		name: 'getRoleAdmin',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'staker',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'getStake',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'getTotalStake',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'token',
				type: 'address'
			}
		],
		name: 'getTotalStakers',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'hasRole',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'owner',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'pendingOwner',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'proxiableUUID',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes4',
				name: 'interfaceId',
				type: 'bytes4'
			}
		],
		name: 'supportsInterface',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'unstakePeriod',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'UPGRADE_INTERFACE_VERSION',
		outputs: [
			{
				internalType: 'string',
				name: '',
				type: 'string'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'WHITELIST_ADMIN_ROLE',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'WHITELISTED_ROLE',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	}
] as const
